const get = (obj: any, path: any, defValue: any) => {
  // If path is not defined or it has false value
  if (!path) return undefined;
  // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
  // Regex explained: https://regexr.com/58j0k
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  // Find value
  const result = pathArray.reduce(
    (prevObj: any, key: any) => prevObj && prevObj[key],
    obj,
  );
  // If found value is undefined return default value; otherwise return the value
  return result === undefined ? defValue : result;
};

class GenericHelpersClass {
  replaceVars(inputString: string, params: unknown, prefix: string): string {
    if (!inputString || !prefix) {
      return inputString;
    }

    let processedString = inputString;
    if (params) {
      processedString = processedString.replace(/{([\s\S]+?)}/g, (val) => {
        let repl = val.slice(1, -1).trim();
        if (repl.indexOf(prefix) === 0) {
          repl = repl.substring(prefix.length);
        }
        return get(params, repl, val);
      });
    }
    processedString = processedString.replace(
      new RegExp('\\{' + this.escapeRegExp(prefix) + '[^\\}]+\\}', 'g'),
      '',
    );

    return processedString;
  }

  private escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}

export const GenericHelpers = new GenericHelpersClass();
